exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".chat-thanks-wraper h4{padding:20px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/sass-loader/dist/cjs.js!./components/chat/styles/thanks.scss
// module id = 1170
// module chunks = 0 1